import { Controller } from "@hotwired/stimulus"

// Top nav date range picker — popover-only logic.
// Date selection is handled by the shared date-range-picker controller
// inside the V2::DateRangePickerComponent.
export default class extends Controller {
  static targets = ["displayFrom", "displayTo", "popover"]

  connect() {
    this.open = false

    // Close popover on outside click
    this.outsideClickHandler = (e) => {
      if (this.open && !this.element.contains(e.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.outsideClickHandler)

    // Close on Escape
    this.escapeHandler = (e) => {
      if (e.key === "Escape" && this.open) {
        this.close()
      }
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
    document.removeEventListener("keydown", this.escapeHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.open ? this.close() : this.show()
  }

  show() {
    this.open = true
    this.popoverTarget.classList.remove("hidden")
  }

  close() {
    this.open = false
    this.popoverTarget.classList.add("hidden")
  }

  // Called when the shared date-range-picker dispatches a "changed" event
  dateChanged(event) {
    const { from, to } = event.detail
    if (this.hasDisplayFromTarget) {
      this.displayFromTarget.textContent = this.formatDisplay(from)
    }
    if (this.hasDisplayToTarget) {
      this.displayToTarget.textContent = this.formatDisplay(to)
    }
  }

  // Apply button — close popover and submit the form
  apply(event) {
    event.preventDefault()
    this.close()
    this.element.closest("form")?.requestSubmit()
  }

  // --- Helpers ---

  formatDisplay(isoStr) {
    const d = new Date(isoStr + "T00:00:00")
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }
}
